import { useEffect, useState } from "react";
import {
  API_GET_BOARD,
  API_GET_CLASS_GRADE,
  API_GET_FOCUS,
  API_GET_GENDER,
  API_GET_MEDIUM_OF_INSTRUCTION,
  API_LEARNING_PREFERENCE,
  API_V1_FOCUES,
} from "../../utils/api-routes";
import { useApi } from "../../hooks/use-api";
import { COOKIE_ACCESS_MAIL } from "../../utils/storage-constants";
import { useNotify } from "../../hooks/use-notify";
import { useAuth } from "../../hooks/use-auth";
import { useNavigate } from "react-router-dom";
import { ROUTE_INFO_SUCCESS } from "../../route";

const useHandler = () => {
  const BOARDS = [
    {
      id: 1,
      title: "CBSE Board",
      subtitle: "Central Board of Secondary Education",
      icon: "📘",
    },
    {
      id: 2,
      title: "ICSE Board",
      subtitle: "Indian Certificate of Secondary Education",
      icon: "🟩",
    },
    {
      id: 3,
      title: "State Board",
      subtitle: "Regional State curriculum",
      icon: "🟥",
    },
    {
      id: 4,
      title: "NEET",
      subtitle: "Medical entrance",
      icon: "⚕️",
    },
    {
      id: 5,
      title: "JEE Main",
      subtitle: "Engineering entrance",
      icon: "⚙️",
    },
    {
      id: 6,
      title: "JEE Advanced",
      subtitle: "IIT Entrance",
      icon: "🎓",
    },
    {
      id: 7,
      title: "UPSC",
      subtitle: "Civil Services",
      icon: "🏛️",
    },
    {
      id: 8,
      title: "SSC",
      subtitle: "Staff Selection",
      icon: "📄",
    },
    {
      id: 9,
      title: "CAT",
      subtitle: "MBA Entrance",
      icon: "📊",
    },
    {
      id: 10,
      title: "GATE",
      subtitle: "Graduate Aptitude Test",
      icon: "👨‍💻",
    },
    {
      id: 11,
      title: "CLAT",
      subtitle: "Law Entrance",
      icon: "⚖️",
    },
    {
      id: 12,
      title: "NDA",
      subtitle: "National Defence Academy",
      icon: "🪖",
    },
  ];

  const BOARD_CONFIG = {
    CBSE: {
      icon: "📘",
      subtitle: "Central Board of Secondary Education",
    },
    TN_STATE_BOARD: {
      icon: "🟥",
      subtitle: "Tamil Nadu State Board",
    },
    TNPSC: {
      icon: "🏛️",
      subtitle: "Tamil Nadu Public Service Commission",
    },
    NEET: {
      icon: "⚕️",
      subtitle: "Medical Entrance",
    },
    JEE: {
      icon: "⚙️",
      subtitle: "Engineering Entrance",
    },
    UPSC: {
      icon: "🏛️",
      subtitle: "Civil Services Examination",
    },
    "Communicative English": {
      icon: "🗣️",
      subtitle: "English Communication Skills",
    },
  };

  const COURSE_FOCUS = [
    "TNPSC",
    "NEET",
    "JEE",
    "UPSC",
    "Communicative English",
  ];

  const DEFAULT_ERROR_STATE = {
    errInstitution: "",
    errMediumOfInstruction: "",
    errGender: "",
    errEducationLevel: "",
    errGradeClass: "",
    errBoard: "",
    errSection: "",
    isClicked: false,
    isValid: false,
  };

  const { persistSession } = useAuth();
  const { get, post } = useApi();
  const { toggleNotify } = useNotify();
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [selectedBoards, setSelectedBoards] = useState([]);
  const [genders, setGenders] = useState([]);
  const [boards, setBoards] = useState();
  const [gradeClass, setGradeClass] = useState([]);
  const [focuss, setFocuss] = useState([]);
  const [mediumInstruction, setMediumInstrction] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [focusRes, setFocusRes] = useState();
  const [data, setData] = useState({
    board: "",
    institution: "",
    gender: "",
    grade: "",
    medium_of_instruction: "",
    section: "",
  });
  const [error, setError] = useState(DEFAULT_ERROR_STATE);
  const textOnlyRegex = /^[A-Za-z\s]+$/;

  const { board, institution, gender, grade, medium_of_instruction, section } =
    data;

const selectedCourses = selectedBoards.map((item) => item.title);

const hasSchoolCourse = selectedCourses.some((course) =>
  ["CBSE", "TN_STATE_BOARD", "ICSE", "CAIE"].includes(course),
);

const hasNeetOrJee = selectedCourses.some((course) =>
  ["NEET", "JEE"].includes(course),
);
  
  const showOnlyInstitutionAndMedium =
    focusRes?.length > 0 &&
    focusRes?.every((board) => COURSE_FOCUS.includes(board));

  const toggleBoard = (board) => {
    setSelectedBoards((prev) => {
      const exists = prev.some((item) => item.id === board.id);

      if (exists) {
        return prev.filter((item) => item.id !== board.id);
      }

      return [...prev, board];
    });
  };

  const onChangeValue = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({ ...prev, [name]: value }));
  };

  const getGenders = async () => {
    try {
      const res = await get(API_GET_GENDER);
      if (res) {
        setGenders(res?.data?.gender || []);
      }
    } catch (e) {
      console.log("ERROR COMES FROM API GENDER", e);
    }
  };

  const getBoards = async () => {
    try {
      const res = await get(API_GET_BOARD);
      if (res) {
        setBoards(res?.data?.board || []);
      }
    } catch (e) {
      console.log("ERROR COMES FROM API BOARD", e);
    }
  };

  const getClassAndGrade = async () => {
    try {
      const res = await get(API_GET_CLASS_GRADE);
      if (res) {
        setGradeClass(res?.data?.class_grade || []);
      }
    } catch (e) {
      console.log("ERROR COMES FROM API CLASS AND GRADE", e);
    }
  };

  const getFocus = async () => {
    try {
      const res = await get(API_GET_FOCUS);
      if (res) {
        setFocuss(res?.data?.focus || []);
      }
    } catch (e) {
      console.log("ERROR COMES FROM API FOCUS", e);
    }
  };

  const getMediumOfInstructions = async (selectedFocus) => {
    try {
      if (!selectedFocus?.length) {
        setMediumInstrction([]);
        return;
      }

      const query = selectedFocus
        .map(({ title }) => `focus=${encodeURIComponent(title)}`)
        .join("&");

      const res = await get(`${API_GET_MEDIUM_OF_INSTRUCTION}?${query}`);

      if (res) {
        setMediumInstrction(res?.data?.medium_of_instruction || []);
      }
    } catch (e) {
      console.log("ERROR COMES FROM API MEDIUM OF INSTRUCTION", e);
    }
  };

  useEffect(() => {
    getGenders();
  }, []);

  useEffect(() => {
    getBoards();
  }, []);

  useEffect(() => {
    getClassAndGrade();
  }, []);

  useEffect(() => {
    getFocus();
  }, []);

  const boardCards = focuss?.map((title, index) => ({
    id: index + 1,
    title,
    icon: BOARD_CONFIG[title]?.icon || "📚",
    subtitle: BOARD_CONFIG[title]?.subtitle || "",
  }));

  const onValidate = () => {
    let errState = { ...DEFAULT_ERROR_STATE, isValid: true, isClicked: true };
    if (!showOnlyInstitutionAndMedium) {
      if (!grade) {
        errState.errGradeClass = "Select grade";
        errState.isValid = false;
      }
      if (!board) {
        errState.errBoard = "Select board";
        errState.isValid = false;
      }

      if (!section) {
        errState.errSection = "Select Section";
        errState.isValid = false;
      }
    }

    if (!institution.trim()) {
      errState.errInstitution = "Enter institution";
      errState.isValid = false;
    } else if (!textOnlyRegex.test(institution.trim())) {
      errState.errInstitution = "Please enter a valid institute name";
      errState.isValid = false;
    }

    if (!medium_of_instruction) {
      errState.errMediumOfInstruction = "Select medium";
      errState.isValid = false;
    }

    setError(errState);
    return errState;
  };

  useEffect(() => {
    if (selectedBoards.length > 0) {
      getMediumOfInstructions(selectedBoards);
    } else {
      setMediumInstrction([]);
    }
  }, [selectedBoards]);

  const email = localStorage.getItem(COOKIE_ACCESS_MAIL);

  const onSubmit = async () => {
    const { isValid } = onValidate();

    if (!isValid) return;

    const payload = {
      email,
      institution,
      medium_of_instruction,
    };

    if (!showOnlyInstitutionAndMedium) {
      payload.class_grade = grade;
      payload.board = board;
      payload.section = section;
    }
    if (showOnlyInstitutionAndMedium && hasNeetOrJee) {
      payload.grade = grade;
    }
    setIsLoading(true);
    try {
      const res = await post(API_LEARNING_PREFERENCE, payload);
      if (res) {
        // store datas
        navigate(ROUTE_INFO_SUCCESS);
        toggleNotify({
          type: "success",
          title: "Signup Successful",
          description:
            res?.data?.message || "You have been registered successfully.",
        });
        setIsLoading(false);
      }
    } catch (e) {
      console.log("ERROR COMES FROM LEARNING PREFERENCES", e);
      setIsLoading(false);
    }
  };

  const onFoucess = async () => {
    const payload = {
      email,
      focus: selectedBoards?.map((item) => item.title),
    };
    try {
      const res = await post(API_V1_FOCUES, payload);
      if (res) {
        setFocusRes(res?.data?.focus);
        setStep(2);
      }
    } catch (e) {
      console.log("ERROR COMES FROM LEARNING PREFERENCES", e);
    }
  };

  const learningPreference = async (payload) => {
    setIsLoading(true);
    try {
      const response = await post(API_LEARNING_PREFERENCE, {
        payload,
      });

      const apiData = response?.data;

      if (!apiData?.role) {
        throw new Error(
          apiData?.message || "Invalid login response from server",
        );
      }

      persistSession(apiData);

      toggleNotify({
        type: "success",
        title: "Welcome",
        description: apiData.message || "Successfully registered",
      });

      return apiData;
    } catch (error) {
      const errorMsg =
        error?.response?.data?.detail ||
        error?.response?.data?.message ||
        error.message ||
        "Connection failed";
      toggleNotify({
        type: "error",
        title: "Login Failed",
        description: errorMsg,
      });
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    boardCards,
    step,
    selectedBoards,
    genders,
    boards,
    data,
    gradeClass,
    error,
    showOnlyInstitutionAndMedium,
    mediumInstruction,
    focusRes,
    setStep,
    setSelectedBoards,
    toggleBoard,
    onChangeValue,
    onFoucess,
    onSubmit,
    hasNeetOrJee,
  };
};

export default useHandler;
